export const FILE_EXTENSIONS = {
  KML: '.kml',
}
